var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"barraProg",attrs:{"id":"Prog"}},[_c('div',{staticClass:"box"},[_c('svg',[_c('circle',{attrs:{"cx":"52","cy":"52","r":"48"}}),_c('circle',{attrs:{"id":"circleProgress","cx":"52","cy":"52","r":"48"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }